import type { DynamicClient } from '../../../client/types';
import { getCore } from '../../../client/core/getCore';
import { subscribeWithSelector } from '../../../utils/observable/subscribeWithSelector';
import { logout } from '../logout';
import { setLongTimeout } from './setLongTimeout';

/**
 * Sets up a timeout to log out the user when their token expires.
 */
export const initializeAuth = (client: DynamicClient) => {
  const core = getCore(client);

  let clearExpirationTimeout: VoidFunction | null = null;

  const onChangeExpiration = subscribeWithSelector(
    core.state,
    (state) => state.sessionExpiresAt
  );

  const checkExpiration = () => {
    const expiration = core.state.get().sessionExpiresAt;

    clearExpirationTimeout?.();

    if (!expiration) {
      return;
    }

    const now = new Date();

    const timeUntilExpiration = expiration.getTime() - now.getTime();

    if (timeUntilExpiration <= 0) {
      void logout(client);
      return;
    }

    // Wait for token expiration
    clearExpirationTimeout = setLongTimeout(
      checkExpiration,
      timeUntilExpiration
    );
  };

  onChangeExpiration(checkExpiration);

  checkExpiration();
};
